var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6212_20524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21429 0C4.012 0 2.21429 1.79771 2.21429 4C2.21429 5.37714 2.91714 6.60114 3.98229 7.32171C1.944 8.196 0.5 10.2171 0.5 12.5714H1.64286C1.64286 10.04 3.68286 8 6.21429 8C7.00057 8 7.73086 8.20457 8.37429 8.55429C7.71602 9.36759 7.35696 10.3823 7.35714 11.4286C7.35714 13.9463 9.41086 16 11.9286 16C14.4463 16 16.5 13.9463 16.5 11.4286C16.5 8.91086 14.4463 6.85714 11.9286 6.85714C10.9657 6.85844 10.028 7.16448 9.24971 7.73143C8.99714 7.57314 8.724 7.44 8.44629 7.32114C8.99013 6.95437 9.4357 6.4598 9.74394 5.88078C10.0522 5.30175 10.2137 4.65596 10.2143 4C10.2143 1.79771 8.41657 0 6.21429 0ZM6.21429 1.14286C7.79886 1.14286 9.07143 2.41543 9.07143 4C9.07143 5.58457 7.79886 6.85714 6.21429 6.85714C4.62971 6.85714 3.35714 5.58457 3.35714 4C3.35714 2.41543 4.62971 1.14286 6.21429 1.14286ZM11.9286 8C13.8291 8 15.3571 9.528 15.3571 11.4286C15.3571 13.3291 13.8291 14.8571 11.9286 14.8571C10.028 14.8571 8.5 13.3291 8.5 11.4286C8.5 9.528 10.028 8 11.9286 8ZM10.6257 9.30286L9.80286 10.1257L11.1074 11.4286L9.80457 12.7314L10.6257 13.5543L11.9286 12.2497L13.2314 13.5526L14.0543 12.7314L12.7497 11.4286L14.0526 10.1257L13.2314 9.30286L11.9286 10.6074L10.6257 9.30457V9.30286Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54346 9.98644L10.486 9.04395V9.04591L11.9782 10.5382L13.4705 9.04395L14.4111 9.98644L12.9188 11.4787L14.413 12.971L13.4705 13.9115L11.9782 12.4193L10.486 13.9135L9.54542 12.971L11.0377 11.4787L9.54346 9.98644Z",
    fill: "#F34336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6212_20524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.4bcb2052.svg";
export { ForwardRef as ReactComponent };